<template>
    <div class="tsa-radioV2" :class="[value === trueLabel ? 'checked' : '', ]" @click="choose">
        <span class="icon" :class="value === trueLabel ? 'tsa-icon-danxuanxuanzhong' : 'tsa-icon-danxuan-weixuanzhong'"></span>
        <p><slot></slot></p>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: [Boolean, String, Number, null],
            default: false
        },
        trueLabel: {
            type: [Boolean, String, Number, null],
            default: true
        },
        falseLabel: {
            type: [Boolean, String, Number, null],
            default: false
        },
        // 如果是自定义
        customRaido: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        choose () {
            if (this.customRaido) {
                this.$emit('on-click')
                return
            }
            let value
            if (this.value !== this.trueLabel) {
                value = this.trueLabel
            } else if (this.value === this.trueLabel) {
                return
            } else {
                value = !this.value
            }
            this.$emit('input', value)
            this.$emit('on-change', value)
        }
    }
}
</script>

<style lang="scss" scoped>
    .tsa-radioV2 {
        display: flex;
        align-items: center;
        cursor: pointer;
        &.checked {
            .icon {
                color: #5887FF;
            }
        }
        .icon {
            color: #B3B3B3;
            font-size: 16px;
            margin-right: 8px;
            color: #B8CCFF;
        }
        p {
            font-size: 16px;
            color: #000000;
        }
    }

</style>